import { Protected } from "%helpers";
import Permission from "%const/permissions";

export default {
  components: {
    Protected
  },

  data() {
    return {
      Permission: Object.values(Permission)
        .flatMap(p => Object.keys(p))
        .reduce((acc, curr) => {
          acc[curr] = curr;
          return acc;
        }, {})
    };
  },

  methods: {
    hasPermission(permission) {
      return this.$store.getters.permissions.includes(permission);
    }
  }
};
